import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import CanopyInput from '../../../../canopy-ui-components/components/CanopyInput/CanopyInput';
import Tags from '../../../../canopy-ui-components/components/Tags/Tags';
import { useCurrentColors } from '../../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import FileName from '../../FileName';
import CustomTags from '../tags/CustomTags';
import SecurityTags from '../tags/SecurityTags';
import TransactionTags from '../tags/TransactionTags';

function EditFileDetails({
    inputFiles,
    globalProps,
    isFinalState,
    userId,
    updateFiles,
}: any) {
    const { t } = globalProps;
    const currentColors = useCurrentColors();
    const handleDescriptionChange = (description: any, index: number) => {
        const newInputFiles = [...inputFiles];
        newInputFiles?.splice(index, 1, {
            ...newInputFiles[index],
            description,
        });
        updateFiles(newInputFiles);
    };
    const handlePasswordChange = (password: any, index: number) => {
        const newInputFiles = [...inputFiles];
        newInputFiles?.splice(index, 1, {
            ...newInputFiles[index],
            password,
        });
        updateFiles(newInputFiles);
    };

    const handleTransactionTagsUpdate = (
        transactionTags: string[],
        index: number
    ): void => {
        const newInputFiles = [...inputFiles];
        newInputFiles?.splice(index, 1, {
            ...newInputFiles[index],
            transactionTags,
        });
        updateFiles(newInputFiles);
    };
    const handleSecurityTagsUpdate = (
        securityTags: string[],
        index: number
    ) => {
        const newInputFiles = [...inputFiles];
        newInputFiles?.splice(index, 1, {
            ...newInputFiles[index],
            securityTags,
        });
        updateFiles(newInputFiles);
    };
    const handleCustomTagsUpdate = (customTags: string[], index: number) => {
        const newInputFiles = [...inputFiles];
        newInputFiles?.splice(index, 1, {
            ...newInputFiles[index],
            customTags,
        });
        updateFiles(newInputFiles);
    };

    return (
        <>
            {inputFiles?.length ? (
                <VStack spacing="15px">
                    <>
                        <HStack
                            spacing="15px"
                            mt="15px"
                            pl="20px"
                            width="100%">
                            <Flex
                                width="300px"
                                minWidth="300px">
                                <Box
                                    fontSize="16px"
                                    fontWeight="bold">
                                    {t('ui.mm.table-headers.file-name')}
                                </Box>
                            </Flex>
                            <Flex
                                width="200px"
                                minWidth="200px"
                                align="flex-start">
                                <Box
                                    fontSize="16px"
                                    fontWeight="bold">
                                    {t('ui.mm.file-details')}
                                </Box>
                            </Flex>
                            <Flex
                                flexGrow={1}
                                width="100%"
                                align="flex-start">
                                <Box
                                    fontSize="16px"
                                    fontWeight="bold">
                                    {t('ui.mm.tags')}
                                </Box>
                            </Flex>
                        </HStack>
                        {inputFiles?.map((file: any, index: number) => {
                            return (
                                <VStack
                                    key={`${file?.name}`}
                                    spacing="15px"
                                    width="100%"
                                    border={`1px solid ${currentColors.componentBorder}`}
                                    borderRadius={'4px'}
                                    padding="20px"
                                    justify="flex-start"
                                    alignItems="flex-start">
                                    <HStack
                                        spacing="15px"
                                        width="100%"
                                        justify="flex-start"
                                        alignItems="flex-start">
                                        <FileName
                                            file={file}
                                            globalProps={
                                                globalProps
                                            }></FileName>
                                        <VStack
                                            width="200px"
                                            minWidth="200px"
                                            spacing="15px"
                                            justify="flex-start"
                                            alignItems="flex-start">
                                            <CanopyInput
                                                onChange={(e) =>
                                                    handleDescriptionChange(
                                                        e.target.value,
                                                        index
                                                    )
                                                }
                                                value={file?.description}
                                                placeholder={t('description')}
                                                isDisabled={
                                                    isFinalState ||
                                                    file?.status ===
                                                        'in-progress'
                                                }
                                                opacity={
                                                    isFinalState ||
                                                    file?.status ===
                                                        'in-progress'
                                                        ? '0.6 !important'
                                                        : '1'
                                                }
                                                width="100%"
                                                fontSize="13px"
                                                minWidth="100%"
                                                height="30px"
                                                boxShadow="none"
                                                backgroundColor="transparent"
                                                color={
                                                    currentColors.brand['10']
                                                }
                                                _hover={{
                                                    color: currentColors
                                                        .brand[10],
                                                    backgroundColor:
                                                        'transparent',
                                                }}
                                                _focus={{
                                                    color: currentColors
                                                        .brand[10],
                                                    backgroundColor:
                                                        'transparent',
                                                }}
                                                _active={{
                                                    color: currentColors
                                                        .brand[10],
                                                    backgroundColor:
                                                        'transparent',
                                                }}></CanopyInput>
                                            <CanopyInput
                                                onChange={(e: any) => {
                                                    handlePasswordChange(
                                                        e?.target?.value,
                                                        index
                                                    );
                                                }}
                                                value={file?.password}
                                                placeholder={t(
                                                    'password-if-protected'
                                                )}
                                                isDisabled={
                                                    isFinalState ||
                                                    file?.status ===
                                                        'in-progress'
                                                }
                                                opacity={
                                                    isFinalState ||
                                                    file?.status ===
                                                        'in-progress'
                                                        ? '0.6 !important'
                                                        : '1'
                                                }
                                                width="100%"
                                                fontSize="13px"
                                                minWidth="100%"
                                                height="30px"
                                                boxShadow="none"
                                                backgroundColor="transparent"
                                                color={
                                                    currentColors.brand['10']
                                                }
                                                _hover={{
                                                    color: currentColors
                                                        .brand[10],
                                                    backgroundColor:
                                                        'transparent',
                                                }}
                                                _focus={{
                                                    color: currentColors
                                                        .brand[10],
                                                    backgroundColor:
                                                        'transparent',
                                                }}
                                                _active={{
                                                    color: currentColors
                                                        .brand[10],
                                                    backgroundColor:
                                                        'transparent',
                                                }}></CanopyInput>
                                        </VStack>
                                        <VStack
                                            spacing="15px"
                                            flexGrow={1}
                                            width="calc(100% - 530px)"
                                            minWidth="calc(100% - 530px)"
                                            alignItems="normal">
                                            {file?.enabledTags?.length ? (
                                                isFinalState ? (
                                                    <Flex
                                                        justify="center"
                                                        borderRadius="4px"
                                                        width="100%"
                                                        opacity={
                                                            '0.6 !important'
                                                        }
                                                        height="75px"
                                                        color="whiteAlpha.500"
                                                        border={`1px solid ${currentColors.brand['700']}`}>
                                                        <Tags
                                                            display="block"
                                                            tagHeight="20px"
                                                            width="100%"
                                                            height="auto"
                                                            isDisabled={true}
                                                            flexDirection="column"
                                                            items={[
                                                                ...(file?.transactionTags ||
                                                                    []),
                                                                ...(file?.securityTags ||
                                                                    []),
                                                                ...(file?.customTags ||
                                                                    []),
                                                            ]}
                                                            onClick={() => {}}
                                                            globalProps={
                                                                globalProps
                                                            }
                                                            selected=""></Tags>
                                                    </Flex>
                                                ) : (
                                                    <>
                                                        {file?.enabledTags?.includes(
                                                            'transactionTags'
                                                        ) ? (
                                                            <TransactionTags
                                                                userId={userId}
                                                                index={index}
                                                                globalProps={
                                                                    globalProps
                                                                }
                                                                file={file}
                                                                isDisabled={
                                                                    file?.status !==
                                                                    'ready-to-update'
                                                                }
                                                                updateTags={
                                                                    handleTransactionTagsUpdate
                                                                }></TransactionTags>
                                                        ) : null}
                                                        {file?.enabledTags?.includes(
                                                            'securityTags'
                                                        ) ? (
                                                            <SecurityTags
                                                                userId={userId}
                                                                index={index}
                                                                globalProps={
                                                                    globalProps
                                                                }
                                                                file={file}
                                                                isDisabled={
                                                                    file?.status !==
                                                                    'ready-to-update'
                                                                }
                                                                updateTags={
                                                                    handleSecurityTagsUpdate
                                                                }></SecurityTags>
                                                        ) : null}
                                                        {file?.enabledTags?.includes(
                                                            'customTags'
                                                        ) ? (
                                                            <CustomTags
                                                                userId={userId}
                                                                index={index}
                                                                globalProps={
                                                                    globalProps
                                                                }
                                                                file={file}
                                                                isDisabled={
                                                                    file?.status !==
                                                                    'ready-to-update'
                                                                }
                                                                updateTags={
                                                                    handleCustomTagsUpdate
                                                                }></CustomTags>
                                                        ) : null}
                                                    </>
                                                )
                                            ) : (
                                                <Flex
                                                    justify="center"
                                                    borderRadius="4px"
                                                    align="center"
                                                    width="100%"
                                                    height="75px"
                                                    p="10px"
                                                    opacity={
                                                        file?.status ===
                                                            'in-progress' ||
                                                        isFinalState
                                                            ? '0.6 !important'
                                                            : '1'
                                                    }
                                                    color="whiteAlpha.500"
                                                    border={`1px solid ${currentColors.brand['700']}`}>
                                                    {t('ui.mm.no-tags')}
                                                </Flex>
                                            )}
                                        </VStack>
                                    </HStack>
                                </VStack>
                            );
                        })}
                    </>
                </VStack>
            ) : null}
        </>
    );
}

export default EditFileDetails;
